import axios from 'axios';

// Use backend API URL (mocktrail-backend on port 3000)
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:3000';

interface CompanyDetails {
  name: string;
  photoUrl?: string;
}

interface Candidate {
  name: string;
  photoUrl?: string;
}

interface PublicInterviewConfig {
  unique_id: string;
  company_details: CompanyDetails;
  candidate: Candidate;
  metadata?: Record<string, any>;
  expires_at: string;
}

class PublicInterviewService {
  /**
   * Get interview configuration for public interview page
   * No authentication required
   */
  async getInterviewConfig(uniqueId: string): Promise<PublicInterviewConfig> {
    try {
      const response = await axios.get<any>(
        `${API_BASE_URL}/implementor/public/interview-config/${uniqueId}`
      );

      // Handle nested response structure from NestJS backend
      // Response format: { statusCode: 200, data: { success: true, data: { ... } } }
      let actualData = response.data;

      // If response has statusCode and data wrapper, unwrap it
      if (actualData.statusCode && actualData.data) {
        actualData = actualData.data;
      }

      // Now check for success and data
      if (!actualData.success || !actualData.data) {
        throw new Error(actualData.error?.message || 'Failed to fetch interview config');
      }

      return actualData.data;
    } catch (error: any) {
      console.error('Error fetching public interview config:', error);

      if (error.response?.status === 404) {
        throw new Error('Interview not found or has expired');
      }

      throw new Error(error.response?.data?.error?.message || 'Failed to load interview');
    }
  }
}

const publicInterviewService = new PublicInterviewService();
export default publicInterviewService;
export type { PublicInterviewConfig };
